var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "has-margin-top" }, [
    _c(
      "div",
      {
        staticClass: "bp-panel is-form has-no-title",
        staticStyle: { "min-height": "auto" },
      },
      [
        _c(
          "div",
          { staticClass: "panel-content is-table-form" },
          [
            _c("catalog-settings-input", {
              attrs: {
                years: _vm.item.years || [],
                catalogPage: _vm.item.catalogPage || "",
                catalogSettings: _vm.item.catalogSettings || [],
              },
              on: { change: _vm.saveChange },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }